/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable react/no-array-index-key */
// DEPENDENCIES
import React, { useState } from 'react';
import { connect } from 'react-redux';
// COMPONENTS
import { Route, useHistory } from 'react-router-dom';
// ICONS
import {
  TbFolders,
  TbClipboardText,
  TbEdit,
  TbNotes,
  TbLayersLinked,
  TbChartCircles,
  TbChecklist,
  TbMailForward,
  TbChartBar,
  TbMenu,
  TbX,
  TbChartArrows
} from 'react-icons/tb';
import { GiValve, GiKeyCard } from 'react-icons/gi';
// CUSTOM COMPONENTS
import DrawerNav from '../components/DrawerNav';
import CustomBlock from '../components/CustomBlock';
import TopNav from '../components/TopNav';
import NavBlock from '../components/NavBlock';
import SideNav from '../components/SideNav';
import ContentHeader from '../components/ContentHeader';
// ASSETS
import Icon from '../assets/img/icon.svg';
// REDUX
import * as auth from '../redux/authRedux';
import * as projectDetail from '../redux/projectDetailRedux';

const ProjectRoute = ({ component: Component, ...rest }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSideNavCollapsed, setIsSideNavCollapsed] = useState(false);
  const [isSideNavMenuTitleVisible, setIsSideNavMenuTitleVisible] = useState(true);

  const history = useHistory();
  const iconSize = 26;
  const iconSizeLarge = 30;
  const iconColor = 'primary--clr';
  const mainPage = '/projects';

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const navigateToPath = (path) => {
    history.push(path);
    setTimeout(() => {
      setIsDrawerOpen(false);
    }, 250);
  };

  const navBarItems = [
    {
      id: 0,
      iconLeft: <TbNotes className={iconColor} size={iconSize} />,
      to: '/project/edit/',
      name: 'Project Details',
      iconRightBackgroundColor: '',
      link: '/project/edit/',
      isVisible: true
    },
    {
      id: 1,
      iconLeft: <GiKeyCard className={iconColor} size={iconSize} />,
      name: 'Project Access',
      to: '/project/project-access/',
      link: '/project/project-access/',
      isVisible: rest.auth.accessLevel >= 50
    },
    {
      id: 2,
      iconLeft: <TbChartBar className={iconColor} size={iconSize} />,
      name: 'KPI Report',
      to: '/project/kpi-report/',
      link: '/project/kpi-report/',
      isVisible: true
    },
    {
      id: 6,
      iconLeft: <TbChartArrows className={iconColor} size={iconSize} />,
      name: 'Overall Weld Log Report',
      to: '/project/weld-log-report/',
      link: '/project/weld-log-report/',
      isVisible: true
    },
    {
      id: 3,
      iconLeft: <TbLayersLinked className={iconColor} size={iconSize} />,
      name: 'Weld Log',
      to: '/project/weld-log/',
      link: '/project/weld-log/',
      isVisible: true
    },
    {
      id: 4,
      iconLeft: <TbChartCircles className={iconColor} size={iconSize} />,
      name: 'Flange Log',
      to: '/project/flange-log/',
      link: '/project/flange-log/',
      isVisible: true
    },
    {
      id: 5,
      iconLeft: <GiValve className={iconColor} size={iconSize} />,
      name: 'PSV Log',
      to: '/project/psv-log/',
      link: '/project/psv-log/',
      isVisible: true
    },
    {
      id: 6,
      iconLeft: <TbEdit className={iconColor} size={iconSize} />,
      name: 'Test Package Log',
      to: '/project/test-package-log/',
      link: '/project/test-package-log/',
      isVisible: true
    },
    {
      id: 7,
      iconLeft: <TbClipboardText className={iconColor} size={iconSize} />,
      title: 'Daily Forms',
      name: 'Daily Forms',
      to: '/project/daily-forms/',
      link: '/project/daily-forms/',
      isVisible: true
    },
    {
      id: 8,
      iconLeft: <TbChecklist className={iconColor} size={iconSize} />,
      name: 'NDE Request Form',
      to: '/project/nde-request-form/',
      link: '/project/nde-request-form/',
      isVisible: true
    },
    {
      id: 9,
      iconLeft: <TbFolders className={iconColor} size={iconSize} />,
      name: 'Documents',
      to: '/project/documents',
      link: '/project/documents/',
      isVisible: true
    },
  ];

  const topNavMenuItems = [
    {
      id: 1,
      name: 'Projects',
      to: '/projects',
      action: null,
      subMenuItems: null,
      isVisible: rest.auth.accessLevel >= 0,
    },
    {
      id: 2,
      name: 'Clients',
      to: '/management/clients',
      action: null,
      subMenuItems: null,
      isVisible: rest.auth.accessLevel >= 40,
    },
    {
      id: 3,
      name: 'Contractors',
      to: '/management/contractors',
      action: null,
      subMenuItems: null,
      isVisible: rest.auth.accessLevel >= 40,
    },
    {
      id: 4,
      name: 'Users',
      to: '/management/users',
      action: null,
      submenuItems: null,
      isVisible: rest.auth.accessLevel >= 40,
    },
    {
      id: 5,
      name: 'Settings',
      to: '',
      action: null,
      isVisible: rest.auth.accessLevel >= 40,
      submenuItems: [
        {
          id: 1,
          name: 'Notification Emails',
          to: '/management/notification-emails',
          iconLeft: <TbMailForward size={22} className={iconColor} />
        },
      ]
    },
  ];

  return (
    <Route
      {...rest} render={(props) => (
        <>
          <TopNav
            hasReturnAction
            hasReturnActionBackground
            hasNavigation
            hasHeaderTitle
            icon={Icon}
            iconTo={mainPage}
            headerTitle="Precise Tracking"
            userInitials={`${rest.auth.user.firstName[0]}${rest.auth.user.lastName[0]}`}
            menuItems={topNavMenuItems.filter((x) => x.isVisible)}
            menuToggleIcon={
              isDrawerOpen
                ? (
                  <TbX
                    size={iconSizeLarge} className="danger--clr"
                    strokeWidth="3"
                  />
                ) : (
                  <TbMenu
                    size={iconSizeLarge} className="dark-blue--clr"
                    strokeWidth="3"
                  />
                )
            }
            secondaryIconActionOnClick={() => {
              rest.resetProjectDetails();
              rest.logout();
            }}
            onClickAvatar={() => {
              history.push('/my-profile');
            }}
            onClick={() => {
              toggleDrawer();
            }}
          />

          <DrawerNav
            isOpen={isDrawerOpen}
            onClick={() => {
              setIsDrawerOpen(false);
            }}
            onClickLogout={() => {
              rest.resetProjectDetails();
              rest.logout();
            }}
            navigationItems={
              navBarItems.filter((x) => x.isVisible).map((item, index) => (
                <NavBlock
                  isCollapsed={isSideNavCollapsed}
                  tooltipText={item.name}
                  key={index}
                  title={isSideNavMenuTitleVisible ? item.name : ''}
                  titleColor={item.link.includes(rest.path.replace('/:projectId', '')) ? 'info--clr' : 'dark-blue--clr'}
                  backgroundColor={item.link.includes(rest.path.replace('/:projectId', '')) ? 'lighter-blue--sbg' : 'white--sbg'}
                  iconLeft={item.iconLeft}
                  onClick={() => {
                    navigateToPath(`${item.link}${rest.projectDetail.projectId}`);
                  }}
                />
              ))
            }
          />

          <CustomBlock className="content-wrapper">
            <SideNav
              isCollapsible
              isExpanded={!isSideNavCollapsed}
              onClick={() => {
                setIsSideNavCollapsed(!isSideNavCollapsed);

                if (isSideNavCollapsed) {
                  setTimeout(() => {
                    setIsSideNavMenuTitleVisible(true);
                  }, 200);
                } else {
                  setIsSideNavMenuTitleVisible(false);
                }
              }}
            >
              {
                navBarItems.filter((x) => x.isVisible).map((item, index) => (
                  <NavBlock
                    isCollapsed={isSideNavCollapsed}
                    tooltipText={item.name}
                    key={index}
                    title={isSideNavMenuTitleVisible ? item.name : ''}
                    titleColor={item.link.includes(rest.path.replace('/:projectId', '')) ? 'info--clr' : 'dark-blue--clr'}
                    backgroundColor={item.link.includes(rest.path.replace('/:projectId', '')) ? 'lighter-blue--sbg' : 'white--sbg'}
                    iconLeft={item.iconLeft}
                    onClick={() => {
                      navigateToPath(`${item.link}${rest.projectDetail.projectId}`);
                    }}
                  />
                ))
              }
            </SideNav>

            <CustomBlock className="component-wrapper">
              <CustomBlock className="section-title">
                <ContentHeader
                  title={rest.projectDetail.projectName}
                  headerSize="md"
                  containerClassName="pb-0"
                  className="blue--clr alt-font fw-600 pb-0"
                />
              </CustomBlock>
              <Component {...props} />
            </CustomBlock>
          </CustomBlock>
        </>
      )}
    />
  );
};

const mapStateFromProps = (state) => ({ projectDetail: state.projectDetail, auth: state.auth });

export default connect(mapStateFromProps, { ...auth.actions, ...projectDetail.actions })(ProjectRoute);